import React from 'react'
import { Box, Button, Highlight, Icon, Text } from '@node-space/ui-components'

export const NameTilesContanier = ({ children }) => {
  return (
    <Box flexCol gapY={8}>
      {children}
    </Box>
  )
}

interface NameTileProps {
  label: string
  tag?: string
  tileId: string | number
  isLoading?: boolean
  onEdit: () => void
  onDelete: () => void
}

export const NameTile = ({ label, tag, tileId, isLoading, onEdit, onDelete }: NameTileProps) => {
  return (
    <Box
      flex
      justify="between"
      align="center"
      borderRadius={4}
      paddingX={16}
      paddingY={8}
      hasBorder
      {...(isLoading && { background: 'subtle' })}
    >
      <Box flexSize="fill" flex gap={4} paddingR={16} align="center" className="min-w-[0]">
        <Text variant="body-label" className="truncate">
          {label}
        </Text>
        {!!tag && <Highlight variant="emphasis">{tag}</Highlight>}
      </Box>
      <Button
        onClick={onDelete}
        variant="ghost"
        loading={isLoading}
        iconElement={<Icon name="Trash" />}
        name={`delete-${label}-${tileId}`}
      />
      <Button
        onClick={onEdit}
        variant="ghost"
        disabled={isLoading}
        iconElement={<Icon name="SimplePencilCustom" />}
        name={`edit-${label}-${tileId}`}
      />
    </Box>
  )
}
